import React from 'react';
import PropTypes from 'prop-types';
import { StyledBlock, StyledDescription, StyledTitle } from '../StyledComponents';

const Header = ({ title, description, className, isWideBlock }) => (
  <div className={className}>
    <StyledBlock isWideBlock={isWideBlock}>
      <StyledTitle>{title}</StyledTitle>
    </StyledBlock>
    <StyledBlock isWideBlock={isWideBlock}>
      <StyledDescription>{description}</StyledDescription>
    </StyledBlock>
  </div>
);

Header.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};

export default Header;
